import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { usePageTitle } from '../../../Hooks/usePageTitle';
import { showToast } from '../../../Components/Toast/toast';
import useUserStore from '../../../Stores/UserStore';
import { useGoogleTranslate } from '../../../Hooks/useGoogleTranslate';
import './ReferAFriend.css';
import referAFriendImage from '../../../assets/images/refer.png';
import CustomButton from '../../../Components/CustomButton';
import heartDecor from '../../../assets/images/coin-store-figma/decor-heart.svg';

const ReferAFriend = () => {
  const pageTitle = useGoogleTranslate('Refer a Friend');
  const description = useGoogleTranslate('Refer your friends and earn 100 coins for each person you refer who gets a paid subscription');
  const referralCodeLabel = useGoogleTranslate('Referral Code');
  const copyLabel = useGoogleTranslate('Copy');

  usePageTitle(pageTitle);
  const { user } = useUserStore();

  // Get referral code from user object in localStorage
  const referralCode = user?.referral_code || '';

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode)
      .then(() => {
        showToast('Referral code copied to clipboard!', 'success');
      })
      .catch(() => {
        showToast('Failed to copy referral code', 'error');
      });
  };

  return (
    <section className="refer-figma-page">
      <img src={heartDecor} alt="" className="refer-figma-heart" aria-hidden="true" />
      <div className="refer-figma-hero">
        <Container>
          <h1 className="refer-figma-title">{pageTitle}</h1>
        </Container>
      </div>
      <div className="refer-figma-main py-sm-5 py-4">
        <Container className="refer-figma-container">
          <Row>
            <Col xs={12} className="text-center">
              <p className="refer-description">{description}</p>
              <div className="refer-figma-image-shell">
                <img
                  src={referAFriendImage}
                  alt="Refer a Friend"
                  className="refer-image img-fluid mx-auto"
                />
              </div>

              <div className="referral-code-container">
                <div className="text-start">
                  <label className="site-label referral-code-figma-label">
                    {referralCodeLabel}
                    <span className="referral-code-required">*</span>
                  </label>
                  <div className="referral-code-input-group">
                    <input
                      type="text"
                      value={referralCode}
                      readOnly
                      className="referral-code-input"
                    />
                    <CustomButton
                      onClick={handleCopyCode}
                      className="referral-copy-figma-btn"
                    >
                      {copyLabel}
                    </CustomButton>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default ReferAFriend;
